import React, {lazy, Suspense} from 'react'

const DefinitionPageLazy = lazy(() =>
    import('./DefinitionPage')
)

const DefinitionPage = props => (
    <Suspense fallback={null}>
        <DefinitionPageLazy {...props} />
    </Suspense>
)

export default DefinitionPage
